module.exports = __webpack_public_path__ + "img/8.814d69f3.jpg";